// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailH":"H_d2xDetailH__inn2p"};